// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2Q2CC","header":"MergedInvoice_header__30VoY"};